import { render, staticRenderFns } from "./inspection-history.component.vue?vue&type=template&id=979ec964"
import script from "./inspection-history.component.ts?vue&type=script&lang=ts&external"
export * from "./inspection-history.component.ts?vue&type=script&lang=ts&external"
import style0 from "./inspection-history.component.vue?vue&type=style&index=0&id=979ec964&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('979ec964')) {
      api.createRecord('979ec964', component.options)
    } else {
      api.reload('979ec964', component.options)
    }
    module.hot.accept("./inspection-history.component.vue?vue&type=template&id=979ec964", function () {
      api.rerender('979ec964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/inspection-history/inspection-history.component.vue"
export default component.exports